<template>
  <div class="main" v-loading="loading">
    <!-- <el-button class="fr btn" @click="clickOpen">全屏</el-button> -->
    <div id="container" style="height: 420px;"></div>
    <!-- <el-dialog title="" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" fullscreen>
      <div id="container1" style="height: 600px;"></div>
      <span slot="footer" class="dialog-footer">
        <el-button class="mr-20" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
// import echarts from 'echarts'
import { chart } from '../api/index.js'

const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()

export default {
  name: 'chart',
  components: {
    // echarts
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      getData: [], // 节点
      getLinks: [], // 关系
      loading: false,
      myChart: '',
      dialogVisible: false,
      screenWidth: document.body.clientWidth // 屏幕尺寸
    }
  },
  // beforeDestroy () {
  //   this.myChart.clear()
  // },
  mounted () {
    this.chart()
    const that = this
    window.onresize = () => {
      this.fn()
      window.screenWidth = document.body.clientWidth
      that.screenWidth = window.screenWidth
    }
  },

  destroyed () {
    window.onresize = () => {
      this.screenWidth = null
    }
  },

  methods: {
    clickOpen () {
      this.dialogVisible = !this.dialogVisible
    },
    fn () {
      this.loading = true
      delay(() => {
        this.getEcharts() // 执行部分
        this.loading = false
      }, 500)
    },
    chart () {
      this.loading = true
      chart({ id: this.info.id }).then(res => {
        if (!res.data) {
          this.loading = false
          return false
        }
        var data = res.data.nodes.map(x => { // 节点
          var itemStyle = {
            normal: {
              color: '#97C2FC'
            }
          }
          if (x.properties.ntype === 's') {
            itemStyle.normal.color = '#F5B554'
          } else {
            itemStyle.normal.color = '#97C2FC'
          }
          return {
            name: x.properties.name,
            itemStyle: itemStyle,
            value: x.id
          }
        })

        var links = res.data.relationships.map(x => { // 关系
          var source = ''
          var target = ''
          for (var i = 0; i < res.data.nodes.length; i++) {
            if (x.startNode === res.data.nodes[i].id) {
              source = res.data.nodes[i].properties.name
            }
            if (x.endNode === res.data.nodes[i].id) {
              target = res.data.nodes[i].properties.name
            }
          }
          var name = x.properties.labels.join(',')

          return {
            source: source,
            target: target,
            name: name
          }
        })
        var obj = {}
        for (var i = 0; i < data.length; i++) {
          if (!obj[data[i].name]) {
            this.getData.push(data[i])
            obj[data[i].name] = true
          }
        }

        links.forEach(e => {
          const index = this.getLinks.findIndex(x => x.source + x.target === e.source + e.target)
          if (index === -1) {
            this.getLinks.push(e)
          } else {
            this.getLinks[index].name += (',' + e.name)
          }
        })
        this.getContainer(this.getData, this.getLinks)
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    getEcharts () {
      this.getContainer(this.getData, this.getLinks)
    },
    getContainer (data, links) {
      var container = document.getElementById('container')
      data.forEach(e => {
        if (e.name === this.info.name) {
          e.x = container.getBoundingClientRect().width / 2
          e.y = container.getBoundingClientRect().height / 2
          e.fixed = true
        } else {
          e.x = null
          e.y = null
          e.fixed = null
        }
      })
      var waterMarkText = 'TrueLand'
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      canvas.width = canvas.height = 200
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.globalAlpha = 0.08
      ctx.font = '20px Microsoft Yahei'
      ctx.translate(50, 50)
      ctx.rotate(-Math.PI / 4)
      ctx.fillText(waterMarkText, 0, 0)
      this.myChart = echarts.init(document.getElementById('container'))
      this.myChart.clear()
      this.myChart.resize()
      var option = null
      option = {
        backgroundColor: {
          type: 'pattern',
          image: canvas,
          repeat: 'repeat'
        },
        tooltip: {
          formatter: function (x) {
            return x.data.name
          }
        },
        animation: false,
        animationDurationUpdate: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            type: 'graph',
            layout: 'force',
            symbolSize: 80,
            roam: true,
            layoutAnimation: false,
            focusNodeAdjacency: true,
            edgeSymbol: ['circle', 'arrow'],
            edgeSymbolSize: [3, 10],
            force: {
              layoutAnimation: false,
              repulsion: 2000
              // edgeLength: [10, 50]
            },
            draggable: false,
            itemStyle: {
              normal: {
                color: '#97C2FC'
              }
            },
            lineStyle: {
              normal: {
                width: 2,
                color: '#F5825D'
              }
            },
            edgeLabel: {
              normal: {
                show: true,
                formatter: function (x) {
                  return x.data.name
                }
              }
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                }
              }
            },
            data: data,
            links: links
          }
        ]
      }
      if (option && typeof option === 'object') {
        this.myChart.setOption(option, true)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.btn{
  position: relative;
  top: -70px;
}
/deep/.el-dialog__header,/deep/.el-dialog__footer{
  border: none;
  padding: 0;
}
</style>
